module.exports = __webpack_public_path__ + "static/media/user.183b8353.svg";